import React, { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Eshika Jaiswal',
    review: 'As a person who has been struggling with managing stress, this has been a wonderful session of relaxation especially with the clear instructions on breath work. I am definitely going to make it a routine to follow the pranayamas taught during the session. Also, would highly recommend it to begin your yoga journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Sandeep Katta',
    review: 'The level of instruction and flow of practice was quite close to experienced practitioners. Only suggestion would be to include a bit more cardio at the start of the session and make the practice more dynamic. Thank you!',
    rating: 4,
  },
  {
    id: 3,
    name: 'Sonal Gupta',
    review: 'The class was great. Nivya is very good at giving instructions. She also corrected me if I made wrong poses during class. I would really recommend to anyone out there who is newbie in yoga or have earlier done before to join this class and give it a shot.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Saurabh Usgaonkar',
    review: 'Nivya is an experienced yoga practitioner. She has gathered knowledge from different sources and has put together a set of some effective yoga practices. Nivya’s art of presentation and communication is simple and easy to understand. The 45-minute session was a thorough overhauling of the body and mind. Highly recommended for beginners as well as regular yoga practitioners. ',
    rating: 5,
  },
  {
    id: 5,
    name: 'Sonal Gupta',
    review: 'The class was great. Nivya is very good at giving instructions. She also corrected me if I made wrong poses during class. I would really recommend to anyone out there who is newbie in yoga or have earlier done before to join this class and give it a shot.',
    rating: 5,
  },
  {
    id: 6,
    name: 'Apoorva Shankar',
    review: 'Thank you for the incredible class last night! This was a session I didn’t know I needed! The instructions were clear and very easy to follow even as a beginner. I liked the order we followed - it systematically helped relieve stress. The inventory we took of our bodies improved self awareness significantly. All the yogic breathing techniques helped me clear my mind and release all lingering negative energies. Thank you once again! I highly recommend taking this class and can’t wait to sign up for more!',
    rating: 5,
  },
  {
    id: 7,
    name: 'Jahnavi Gandhi',
    review: 'This was my first class with Nivya. She is a great instructor and was able to tune the class to my level (beginner). She was extremely professional and gave clear instructions and options for adjustments. The class was also structured in a way to slowly increase intensity and stretching and left me feeling energized and ready for the day!',
    rating: 5,
  }
];

const TestimonialCarousel = () => {
  // State to keep track of the current slide
  const [currentSlide, setCurrentSlide] = useState(0);

  // Handle next and previous slide
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="testimonial-carousel">
      <h2>What Our Clients Say</h2>

      <div className="carousel-container">
        <div className="testimonial-card">
          <div className="stars">
            {[...Array(testimonials[currentSlide].rating)].map((_, index) => (
              <span key={index} className="star">★</span>
            ))}
          </div>
          <p className="testimonial-description">{testimonials[currentSlide].review}</p>
          <p className="testimonial-name">- {testimonials[currentSlide].name}</p>
        </div>

        {/* Navigation buttons */}
        <button className="carousel-nav prev" onClick={prevSlide}>❮</button>
        <button className="carousel-nav next" onClick={nextSlide}>❯</button>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
